
import { City, LatitudeLongitude } from "@/models/City";
import { MapOptions, Polyline, PolylineIcon } from "@/models/Map";
import { ActionRefData, QuestMapPoi } from "@/models/MapPois/Quest/QuestMapPoi";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
class Map extends Vue {
  @Prop({ default: true }) readonly showSearch!: boolean;
  @Prop({ default: 15 }) readonly zoomLevel!: number;
  @Prop({ default: null }) readonly centerPoint!: LatitudeLongitude;
  @Prop({ default: false }) readonly showPolyLines!: boolean;
  @Prop({ default: null }) readonly mapMarkersArray!: MapOptions[];
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  @Prop({ default: false }) readonly hideSearch!: boolean;
  @Prop({ default: false }) readonly small!: boolean;
  @Prop({ default: "View" }) readonly setInfoButton!: string;
  @Prop({ default: false }) readonly showGeoFence!: boolean;
  @Prop({ default: 15 }) readonly GeoNumber!: number;
  @Prop({ default: false }) readonly showGeoFenceSlider!: boolean;

  searchFilter = "";
  infoWindowPos = null;
  infoWinOpen = false;
  currentMidx = null;
  mapSlug = "";
  mapTitle = "";
  zIndex = 0;
  isRunaway = false;
  optionArray: any[] = [];
  pathArray: any[] = [];
  geoRange = 10;
  single = false;

  getRadius(radius: number): number {
    if (this.showGeoFenceSlider) {
      if (radius !== undefined) return Number(this.geoRange);
      return 0;
    } else {
      if (radius !== undefined) return Number(radius);
      return 0;
    }
  }

  get getMapMarkers(): MapOptions[] {
    return this.mapMarkersArray.reverse();
  }

  get getMapSize(): string {
    if (this.small) {
      return "height: 160px";
    }
    return "height: 300px";
  }

  get getCityData(): City {
    return this.$store.state.cityStore.singleCity;
  }
  get getMapPoiData(): QuestMapPoi[] {
    return this.$store.state.mapPoiStore.questMapPoi;
  }

  get infoButtonString(): string {
    if (this.setInfoButton === "Set Target") {
      if (this.isRunaway) {
        return "Unset Target";
      }
    }
    return this.setInfoButton;
  }

  setPlace(place: any): void {
    var data = {
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng(),
    };
    this.$emit("mapData", data);
  }

  setPlaceRightClick(place: any): void {
    if (!this.isEditingLocked) {
      var data = {
        latitude: place.latLng.lat(),
        longitude: place.latLng.lng(),
      };
      this.$emit("mapData", data);
    }
  }
  updateDetails(place: any): void {
    var data = {
      latitude: place.latLng.lat(),
      longitude: place.latLng.lng(),
    };
    this.$emit("mapData", data);
  }

  placePoint(place: any): void {
    var data = {
      latitude: place.latLng.lat(),
      longitude: place.latLng.lng(),
    };
    this.$emit("mapData", data);
  }

  getGeoFenceOptions(color: string, opacity: number): any {
    var data = {
      fillColor: color,
      fillOpacity: opacity,
      strokeColor: color,
      strokeOpacity: opacity,
      strokeWeight: 1.0,
    };
    return data;
  }

  toggleInfoWindow(marker: any, idx: any): void {
    if (!this.isEditingLocked) {
      this.infoWindowPos = marker.position;
      this.mapSlug = marker.slug;
      this.mapTitle = marker.title;
      this.isRunaway = marker.isRunaway;
      this.zIndex = marker.zIndex;
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  }
  openLocation(): void {
    this.$emit("openLocation", this.mapSlug);
  }

  getActionRefData(mapOptions: MapOptions): ActionRefData[] {
    var mapPoi = this.getMapPoiData.filter(
      (poi: QuestMapPoi) => poi.key === mapOptions.slug
    )[0];
    if (mapPoi !== undefined && mapPoi.actionGoalRef !== undefined) {
      var results = mapPoi.actionGoalRef.filter(
        (x: ActionRefData) =>
          x.helperPath.includes("poiActiveAction") ||
          x.helperPath.includes("poiVisibilityAction")
      );
      return results;
    }
    return [];
  }

  getPath(results: ActionRefData, mapOptions: MapOptions): any[] {
    var path: any[] = [];
    var data = this.getMapPoiData.filter(
      (x: QuestMapPoi) => x.key === results.id
    )[0];
    if (this.getCityData.locations[data.loc.loc_uid] !== undefined) {
      path.push(
        {
          lat: mapOptions.position.lat,
          lng: mapOptions.position.lng,
        },
        {
          lat: this.getCityData.locations[data.loc.loc_uid].lat_long.latitude,
          lng: this.getCityData.locations[data.loc.loc_uid].lat_long.longitude,
        }
      );
    } else {
      path.push(
        {
          lat: mapOptions.position.lat,
          lng: mapOptions.position.lng,
        },
        {
          lat: data.loc.override_ll.latitude,
          lng: data.loc.override_ll.longitude,
        }
      );
    }
    this.pathArray = path;
    return path;
  }

  getColour(results: ActionRefData, mapOptions: MapOptions): any {
    try {
      var array = results.path.split("/");
      var contentGroup = this.getMapPoiData.filter(
        (poi: QuestMapPoi) => poi.key === mapOptions.slug
      )[0].contentGroups[array[2]];
      var colour = "";
      if (array[3].includes("d1")) {
        colour = this.getD1Colour(
          contentGroup,
          array[5],
          results.id,
          results.questionId || ""
        );
      }
      if (array[3].includes("d2")) {
        colour = this.getD2Colour(contentGroup, array[5], results.id);
      }
      if (array[3] === "mg") {
        if (array.length > 6) {
          if (array[7] === "onIncorrect") {
            colour = this.getMGIncorrectColor(
              contentGroup,
              array[9],
              results.id,
              array[6]
            );
          } else if (array[7] === "onSuccess") {
            colour = this.getMGSuccessColor(
              contentGroup,
              array[9],
              results.id,
              array[6]
            );
          } else {
            colour = this.getMGFailedColor(
              contentGroup,
              array[9],
              results.id,
              array[6]
            );
          }
        } else {
          colour = this.getMGFinalColor(contentGroup, array[5], results.id);
        }
      }
      return this.getColourData(colour);
    } catch (e) {
      console.log(e);
      return this.getColourData("#008000");
    }
  }

  getD1Colour(
    contentGroup: any,
    name: string,
    id: string,
    questionId: string
  ): string {
    if (name === "poiActiveAction") {
      if (
        contentGroup.d1.actions?.poiActiveAction?.upd[id].value == undefined
      ) {
        return contentGroup.d1.questions[questionId].actions?.poiActiveAction
          .upd[id].value == "true"
          ? "#35CDDD"
          : "#9A64CD";
      } else {
        return contentGroup.d1.actions?.poiActiveAction?.upd[id].value == "true"
          ? "#008000"
          : "#FF0000";
      }
    } else {
      if (
        contentGroup.d1.actions?.poiVisibleAction?.upd[id].value == undefined
      ) {
        return contentGroup.d1.questions.actions?.poiVisibleAction.upd[id]
          .value == "true"
          ? "#35CDDD"
          : "#9A64CD";
      } else {
        return contentGroup.d1.actions?.poiVisibleAction?.upd[id].value ==
          "true"
          ? "#008000"
          : "#FF0000";
      }
    }
  }
  getD2Colour(contentGroup: any, name: string, id: string): string {
    if (
      contentGroup !== undefined &&
      contentGroup.d2 !== undefined &&
      contentGroup.d2.actions !== undefined
    ) {
      if (name === "poiActiveAction") {
        return contentGroup.d2.actions?.poiActiveAction?.upd[id].value == "true"
          ? "#008000"
          : "#FF0000";
      } else {
        return contentGroup.d2.actions?.poiVisibleAction?.upd[id].value ==
          "true"
          ? "#008000"
          : "#FF0000";
      }
    } else {
      return "#FF0000";
    }
  }

  getMGIncorrectColor(
    contentGroup: any,
    name: string,
    id: string,
    difficult: string
  ): string {
    if (name === "poiActiveAction") {
      return contentGroup.mg.puzzle.puzzleData[difficult].onIncorrect.actions
        .poiActiveAction?.upd[id].value === "true"
        ? "#008000"
        : "#FF0000";
    } else {
      return contentGroup.mg.puzzle.puzzleData[difficult].onIncorrect.actions
        .poiVisibleAction?.upd[id].value === "true"
        ? "#008000"
        : "#FF0000";
    }
  }

  getMGSuccessColor(
    contentGroup: any,
    name: string,
    id: string,
    difficult: string
  ): string {
    if (name === "poiActiveAction") {
      return contentGroup.mg.puzzle.puzzleData[difficult].onIncorrect.actions
        .poiActiveAction?.upd[id].value === "true"
        ? "#008000"
        : "#FF0000";
    } else {
      return contentGroup.mg.puzzle.puzzleData[difficult].onIncorrect.actions
        .poiVisibleAction?.upd[id].value === "true"
        ? "#008000"
        : "#FF0000";
    }
  }
  getMGFailedColor(
    contentGroup: any,
    name: string,
    id: string,
    difficult: string
  ): string {
    if (name === "poiActiveAction") {
      return contentGroup.mg.puzzle.puzzleData[difficult].onIncorrect.actions
        .poiActiveAction?.upd[id].value === "true"
        ? "#008000"
        : "#FF0000";
    } else {
      return contentGroup.mg.puzzle.puzzleData[difficult].onIncorrect.actions
        .poiVisibleAction?.upd[id].value === "true"
        ? "#008000"
        : "#FF0000";
    }
  }
  getMGFinalColor(contentGroup: any, name: string, id: string): string {
    if (name === "poiActiveAction") {
      return contentGroup.mg.actions.poiActiveAction?.upd[id].value === "true"
        ? "#008000"
        : "#FF0000";
    } else {
      return contentGroup.mg.actions.poiVisibleAction?.upd[id].value === "true"
        ? "#008000"
        : "#FF0000";
    }
  }

  getColourData(colour: string): Polyline {
    var icon = {
      path: 2,
      strokeOpacity: 1,
      strokeColor: colour,
      strokeWeight: 3,
      scale: 3,
    } as PolylineIcon;
    return {
      strokeColor: colour,
      strokeWeight: 3,
      icons: [
        {
          icon: icon,
        },
      ],
    };
  }
}

export default Map;
